/**
 * NDG Riders — view.js
 *
 * Rider modals are handled by the shared ndg/modal store (pool DOM pattern).
 * This store only initialises the Embla drag/scroll on the riders track,
 * via le module partagé ndg/shared-slider.
 */

import { store, getElement } from '@wordpress/interactivity';
import { initSlider as initEmblaSlider } from '../../js/utils/slider.js';

store( 'ndg/riders', {
	callbacks: {
		initSlider() {
			const { ref } = getElement();
			if ( ! ref ) return;

			const embla = initEmblaSlider( ref, {
				wrapperSelector: '.ndg-riders',
				labelSelector:   '.ndg-riders__header p',
				fallbackLabel:   'Riders',
				watchResize:     true,
			} );

			// Filet de sécurité : au moment de l'init, les styles externes
			// (largeur des cards, etc.) ne sont pas toujours encore appliqués
			// (chargement CSS asynchrone) — Embla peut alors mesurer un
			// carrousel sans dépassement et désactiver les flèches à tort.
			// Un reInit() au repaint suivant force une mesure fiable.
			requestAnimationFrame( () => embla.reInit() );
		},
	},
} );
